import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Şifre en az 6 karakter olmalı"); return; }
    if (pw !== pw2) { toast.error("Şifreler eşleşmiyor"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Şifren güncellendi! Şimdi giriş yapabilirsin 🎉");
      navigate("/giris");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Bağlantı geçersiz veya süresi dolmuş");
    } finally {
      setBusy(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4 text-center">
        <div>
          <p className="text-slate-600">Geçersiz bağlantı.</p>
          <Link to="/sifremi-unuttum"><Button className="mt-4 rounded-xl">Yeni bağlantı iste</Button></Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-slate-50 to-sky-50 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl shadow-xl p-8">
          <div className="text-center mb-6">
            <div className="text-4xl">🔒</div>
            <h1 className="font-display text-2xl font-bold text-slate-900 mt-2">Yeni Şifre Belirle</h1>
            <p className="text-slate-500 text-sm mt-1">Hesabın için güçlü bir şifre seç.</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-sm font-semibold">Yeni Şifre</Label>
              <div className="relative mt-1">
                <Lock className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <Input data-testid="reset-password-input" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} placeholder="En az 6 karakter" className="rounded-xl pl-9" />
              </div>
            </div>
            <div>
              <Label className="text-sm font-semibold">Yeni Şifre (Tekrar)</Label>
              <div className="relative mt-1">
                <Lock className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <Input data-testid="reset-password-confirm" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Şifreyi tekrar gir" className="rounded-xl pl-9" />
              </div>
            </div>
            <Button data-testid="reset-submit-btn" type="submit" disabled={busy} className="w-full bg-indigo-600 hover:bg-indigo-700 rounded-xl py-6 font-bold">
              {busy ? "Kaydediliyor..." : "Şifreyi Güncelle"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
